import { wrapText } from "../utils/wrapText"
import css from "./css/stepInfoTab.module.css"
import step1 from "../images/stepInfo/flowpathbox1.png"
import step2 from "../images/stepInfo/flowpathbox2.png"
import step3 from "../images/stepInfo/flowpathbox3.png"
import { useQuery } from "@apollo/client"
import { GET_HOMES } from "../graphql/Home/HOME_GQL"
import { findContentByLabel } from "../utils/findContentByLabel"
import { useMemo } from "react"

const StepInfoTab = () => {
  const { data } = useQuery(GET_HOMES)
  const ContentData = data?.homes

  const title = findContentByLabel(ContentData, "stepInfo_title") || "Online申請 兩步立即批核\n貸款輕鬆到手"
  
  const steps = useMemo(() => [
    { 
      number: "1", 
      text: findContentByLabel(ContentData, "stepInfo_step1_text") || "Online登記", 
      image: step1 
    },
    { 
      number: "2", 
      text: findContentByLabel(ContentData, "stepInfo_step2_text") || "Online簽署", 
      image: step2 
    },
    { 
      number: "3", 
      text: findContentByLabel(ContentData, "stepInfo_step3_text") || "Online過數", 
      image: step3 
    },
  ], [ContentData])

  return (
    <div className={css.container}>
      <h3>{wrapText(title)}</h3>
      <div className={css.stepsContainer}>
        {steps.map((step, index) => (
          <div key={index} className={css.step}>
            <div className={css.stepNumber}>{step.number}</div>
            <div
              className={css.stepText}
              style={{ backgroundImage: `url(${step.image})` }}
            >
              {step.text}
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}

export default StepInfoTab
